import Joi from 'joi';

/**
 * Schema for new record validation.
 */
export const createVehicleInsuranceClaimSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
